//noinspection JSHint
/**
 * Filtert das Ergebnis der Contentsuche auf der Produktliste über AJAX.
 */
import $ from "jquery";

export default function ContentSearchFilterController() {
}

function hideAllSearchEntriesWithoutFilterValue(filterValue) {
  var numberOfDisplayedProducts = 0;
  $("[data-content-search-filter-value]").each(function () {
    var searchEntryValue = $(this).attr('data-content-search-filter-value');
    var $this = $(this);
    var matchesFilter = typeof searchEntryValue !== "undefined" && filterValue.indexOf("|" + searchEntryValue + "|") >= 0;
    if (matchesFilter) {
      $this.show();
      numberOfDisplayedProducts++;
    } else {
      $this.hide();
    }
  });
  updateSearchResultsCount(numberOfDisplayedProducts);
}


function updateSearchResultsCount(count) {
  var $contentTab = $(".tab-headline[data-tab-id='content_tab']");
  var text = $contentTab.text();
  var newText = text.replace(/\(.*\)/i, '(' + count + ')');
  $contentTab.text(newText);
}

function hideAllFiltersExcept($filter) {
  // Filter-Links ausblenden
  $("[data-content-search-filter]").hide();
  $filter.show();

  // Den Container komplett ausblenden, damit die Überschriften weg sind
  $(".jh-wiki-navi-controls").hide();
  $filter.parents(".jh-wiki-navi-controls").show(); // Die eigene Überschrift soll angezeigt werden
}

function showHiddenContentseachElements() {
  $("[data-content-search-filter]").show();
  var allSearchEntries = $("[data-content-search-filter-value]");
  allSearchEntries.show();
  updateSearchResultsCount(allSearchEntries.length);
  $(".jh-wiki-navi-controls").show();
  resetLink().hide();
}

function resetLink() {
  return $(".reset-content-search-filter-link");
}

ContentSearchFilterController.prototype.init = function () {
  $(document).on("click", "[data-content-search-filter]", function () {
    var $clicked_elem = $(this);
    var filterValue = $clicked_elem.attr('data-content-search-filter');
    hideAllSearchEntriesWithoutFilterValue(filterValue);
    hideAllFiltersExcept($clicked_elem);
    resetLink().show();
  });
  $(document).on("click", ".reset-content-search-filter-link", function () {
    showHiddenContentseachElements();
  });
};
